import lahiResultTable from './lahi-result-table/lahi-result-table.vue';
import lahiLoader from '../lahi-loader/lahi-loader.vue';
import { mapState } from 'vuex';
export default {
	components: {
		lahiResultTable,
		lahiLoader
	},
	computed: {
		...mapState('lahi', ['calculationResult', 'calculationInProgress'])
	}
};
